import React from 'react';
import { cn } from '@/lib/utils';
import {
  fieldBase, fieldBorder, fieldBorderError, fieldError, fieldHint, fieldLabel, useFieldId,
} from './fieldStyles';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
}

/** A multi-line text field with the same border, focus and message treatment as Input. */
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, error, hint, id, rows = 4, ...props }, ref) => {
    const fieldId = useFieldId(id, label);
    const messageId = `${fieldId}-message`;
    const hasMessage = Boolean(error || hint);

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={fieldId} className={fieldLabel}>
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={fieldId}
          rows={rows}
          aria-invalid={error ? true : undefined}
          aria-describedby={hasMessage ? messageId : undefined}
          className={cn(fieldBase, 'h-auto py-2 leading-relaxed', error ? fieldBorderError : fieldBorder, className)}
          {...props}
        />
        {error && (
          <p id={messageId} className={fieldError}>
            {error}
          </p>
        )}
        {hint && !error && (
          <p id={messageId} className={fieldHint}>
            {hint}
          </p>
        )}
      </div>
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
